module.exports = __webpack_public_path__ + "static/media/Toyota Faisalabad Motors.78678cb2.jfif";